
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Square = () => (
      <>
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      </>
    );
    export default Square;
    